export enum LogLevel {
  None,
  Error,
  Warn,
  Info,
  Log,
  Debug,
}
